import { defineAsyncComponent } from 'vue'
export default {
  default: defineAsyncComponent(() => import("/opt/buildhome/repo/layouts/default.vue").then(m => m.default || m)),
  embed: defineAsyncComponent(() => import("/opt/buildhome/repo/layouts/embed.vue").then(m => m.default || m)),
  "error-layout": defineAsyncComponent(() => import("/opt/buildhome/repo/layouts/error-layout.vue").then(m => m.default || m))
}